import React, { useMemo } from 'react';
import { ProductionPiece } from 'app/models/ProductionPiece';
import { Workstation } from 'app/containers/OrderDetails/types';
import { PartOrder } from 'app/models/PartOrder';
import PickingPageView from 'shared/printing/pickingPresentation/PickingPageView';
import { createTextLineCounter } from 'shared/printing/pickingPresentation';
import { PickingOrderStrategy } from 'shared/printing/pickingOrder';

interface Props {
  order: PartOrder;
  pieces: ProductionPiece[];
  workstation: Workstation;
  trolleyName?: string;
  drawerPieces?: ProductionPiece[];
  pickingOrderStrategy: PickingOrderStrategy;
}

const PickingPagePrintable = ({
  order,
  pieces,
  workstation,
  trolleyName,
  drawerPieces,
  pickingOrderStrategy,
}: Props) => {
  const countTextLines = useMemo(() => createTextLineCounter('estimate'), []);

  return (
    <PickingPageView
      order={order}
      pieces={pieces}
      workstation={workstation}
      trolleyName={trolleyName}
      drawerPieces={drawerPieces}
      countTextLines={countTextLines}
      pickingOrderStrategy={pickingOrderStrategy}
    />
  );
};

export default PickingPagePrintable;
